<template>
  <div class="flex flex-wrap diygw-col-24 footer-flex22-clz">
    <div class="flex flex-wrap diygw-col-9 justify-start footer-flex24-clz">
      <img :src='this.$store.state.crmURL + "/dt/logo.png"' class="image2-size diygw-image diygw-col-12 image-clz" mode="widthFix" />
    </div>
    <div class="flex flex-wrap diygw-col-15 justify-start footer-flex25-clz">
      <div class="flex diygw-autoview diygw-col-24 footer-autoview3-clz">
        <div class="diygw-absolute footer-autoview3_0">
          <a class="diygw-col-24 footer-text46-clz" href="javascript:void(0);" @click="redrect2Url('home')">首页</a>
        </div>
      </div>
      <div class="flex diygw-autoview diygw-col-24 footer-autoview3-clz">
        <div class="diygw-absolute footer-autoview3_0">
          <a class="diygw-col-24 footer-text46-clz" href="javascript:void(0);" @click="redrect2Url('serve')">我们是谁</a>
        </div>
      </div>
      <div class="flex diygw-autoview diygw-col-24 footer-autoview5-clz">
        <div class="diygw-absolute footer-autoview5_0">
          <a class="diygw-col-24 footer-text44-clz" href="javascript:void(0);" @click="redrect2Url('serve')">我们提供的服务</a>
        </div>
        <div class="diygw-absolute footer-autoview5_1">
          <div class="diygw-col-24 footer-text45-clz">产品服务</div>
        </div>
        <div class="diygw-absolute footer-autoview5_2">
          <div class="diygw-col-24 footer-text47-clz">规划报告</div>
        </div>
        <div class="diygw-absolute footer-autoview5_3">
          <div class="diygw-col-24 footer-text48-clz">其它服务</div>
        </div>
      </div>
      <div class="flex diygw-autoview diygw-col-24 footer-autoview5-clz">
        <div class="diygw-absolute footer-autoview5_0">
          <a class="diygw-col-24 footer-text44-clz" href="javascript:void(0);" @click="redrect2Url('dcha')">洞察</a>
        </div>
        <div class="diygw-absolute footer-autoview5_1">
          <div class="diygw-col-24 footer-text45-clz">产品宏观情况</div>
        </div>
        <div class="diygw-absolute footer-autoview5_2">
          <div class="diygw-col-24 footer-text47-clz">产业未来发展趋势</div>
        </div>
        <div class="diygw-absolute footer-autoview5_3">
          <div class="diygw-col-24 footer-text48-clz">产业劳动力分析</div>
        </div>
      </div>
      <div class="flex diygw-autoview diygw-col-24 footer-autoview5-clz">
        <div class="diygw-absolute footer-autoview5_0">
          <a class="diygw-col-24 footer-text44-clz" href="javascript:void(0);" @click="redrect2Url('contact')">联系我们</a>
        </div>
        <div class="diygw-absolute footer-autoview5_1">
          <div class="diygw-col-24 footer-text45-clz">微信公众号</div>
        </div>
        <div class="diygw-absolute footer-autoview5_2">
          <div class="diygw-col-24 footer-text47-clz">微信</div>
        </div>
        <div class="diygw-absolute footer-autoview5_3">
          <div class="diygw-col-24 footer-text48-clz">小红书</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {

    },
    data(){
      return{
        updateYear: null,
      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      redrect2Url(path) {
        this.$router.push('/' + path);
        this.homeActive = "";
        this.courseActive = "";
        this.programActive = "";
        if (path == "home") {
          this.homeActive = "active";
        } else if (path == "course") {
          this.courseActive = "active";
        } else if (path == "program") {
          this.programActive = "active";
        }
      },
    }
  }
</script>

<style scoped>
  .footer-flex24-clz {
    padding-left: 30px;
  }
  .image2-size {
    width: 250px !important;
  }
  .footer-flex22-clz {
    background-color: #efefef;
    padding-top: 60px;
    padding-left: 0px;
    padding-bottom: 60px;
    padding-right: 0px;
  }

  .footer-flex25-clz {
    margin-left: 0px;
    /*width: calc(70.8333333333% - 0px - 0px) !important;*/
    margin-top: 30px;
    margin-bottom: 15px;
    margin-right: 0px;
  }
  .footer-autoview3-clz {
    flex-shrink: 0;
    z-index: 1000;
    width: 130px !important;
    height: 100px;
  }

  .footer-autoview3_0 {
    left: 0px;
    top: 1px;
    width: 130px;
    height: 40px;
    z-index: 0;
  }
  .footer-autoview3_0 > .flex {
    height: 100%;
  }
  .footer-text46-clz {
    margin-left: 0px;
    color: #3e3a39;
    width: 100% !important;
    font-size: 16px !important;
    margin-top: 10px;
    margin-bottom: 0px;
    text-align: center;
    margin-right: 0px;
  }
  .footer-autoview4_0 > .flex {
    height: 100%;
  }
  .footer-autoview5-clz {
    flex-shrink: 0;
    z-index: 1000;
    width: 130px !important;
    height: 140px;
  }

  .footer-autoview5_0 {
    left: 0px;
    top: 1px;
    width: 130px;
    height: 40px;
    z-index: 0;
  }
  .footer-autoview5_0 > .flex {
    height: 100%;
  }
  .footer-autoview5_1 {
    left: 0px;
    top: 40px;
    width: 130px;
    height: 40px;
    z-index: 0;
  }
  .footer-autoview5_1 > .flex {
    height: 100%;
  }
  .footer-autoview5_2 {
    left: 0px;
    top: 70px;
    width: 130px;
    height: 40px;
    z-index: 0;
  }
  .footer-autoview5_2 > .flex {
    height: 100%;
  }
  .footer-autoview5_3 {
    left: 0px;
    top: 100px;
    width: 130px;
    height: 40px;
    z-index: 0;
  }
  .footer-autoview5_3 > .flex {
    height: 100%;
  }
  .footer-text44-clz {
    margin-left: 0px;
    color: #3e3a39;
    width: 100% !important;
    font-size: 16px !important;
    margin-top: 10px;
    margin-bottom: 0px;
    text-align: center;
    margin-right: 0px;
  }
  .footer-text45-clz {
    margin-left: 0px;
    color: #9c9c9c;
    width: 100% !important;
    font-size: 14px !important;
    margin-top: 10px;
    margin-bottom: 0px;
    text-align: center;
    margin-right: 0px;
  }
  .footer-text47-clz {
    margin-left: 0px;
    color: #9c9c9c;
    width: 100% !important;
    font-size: 14px !important;
    margin-top: 10px;
    margin-bottom: 0px;
    text-align: center;
    margin-right: 0px;
  }
  .footer-text48-clz {
    margin-left: 0px;
    color: #9c9c9c;
    width: 100% !important;
    font-size: 14px !important;
    margin-top: 10px;
    margin-bottom: 0px;
    text-align: center;
    margin-right: 0px;
  }
  @media screen and (max-width: 900px) {
    .footer-flex24-clz {
      /*display: none;*/
    }
    .footer-flex25-clz {
      width: 100% !important;
    }
    .footer-autoview5_1,.footer-autoview5_2,.footer-autoview5_3 {
      display: none;
    }
    .footer-autoview3-clz,.footer-autoview5-clz {
      height: 40px;
      width: 120px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer/Footer.vue